import Swal from "sweetalert2";

export default {
        normalize_answer_for_question(questionSection, answerEntry) {
            const question_type  = this.get_question_type(questionSection);
            const raw_answer = answerEntry?.answer ?? '';

            if (question_type  === 'selection') {
              if (Array.isArray(raw_answer)) {
                return raw_answer;
              }

              return String(raw_answer)
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean);
            }

            return raw_answer;
        },
        get_question_section_id(questionSection) {
            const question = Reflect.get(questionSection || {}, 'question') || {};
            return Reflect.get(question, 'id');
        },
        get_answer_question_id(answerEntry) {
            const question = Reflect.get(answerEntry || {}, 'question') || {};
            return Reflect.get(question, 'id');
        },
        find_answer_for_question(answer_entries, question_id) {
            if (!question_id) {
              return null;
            }

            return answer_entries.find(
              (answerEntry) => String(this.get_answer_question_id(answerEntry)) === String(question_id)
            );
        },
        hydrate_question_answer(questionSection, answer_entries, next_answers) {
            const question_id = this.get_question_section_id(questionSection);
            const existing_answer = this.find_answer_for_question(answer_entries, question_id);

            if (!existing_answer ) {
              return;
            }

            Reflect.set(next_answers, question_id, this.normalize_answer_for_question(
              questionSection,
              existing_answer
            ));
        },
        get_form_id(formItem) {
            return formItem?.form?.id || formItem?.id;
        },
        get_form_answer_entries(formItem) {
            return Array.isArray(formItem?.answers) ? formItem.answers : [];
        },
        mark_form_submitted_from_answers(form_id, answer_entries, next_submitted_ids) {
            if (answer_entries.length > 0 && form_id) {
              Reflect.set(next_submitted_ids, form_id, true);
            }
        },
        hydrate_form_item_answers(formItem, next_answers, next_submitted_ids) {
            const form_id = this.get_form_id(formItem);
            const answer_entries  = this.get_form_answer_entries(formItem);

            this.mark_form_submitted_from_answers(form_id, answer_entries, next_submitted_ids);
            this.get_form_questions(formItem).forEach((questionSection) => {
              this.hydrate_question_answer(questionSection, answer_entries, next_answers);
            });
        },
        is_missing_answer(answer) {
            return answer === undefined || answer === null;
        },
        is_empty_array_answer(answer) {
            return Array.isArray(answer) && answer.length === 0;
        },
        is_empty_string_answer(answer) {
            return typeof answer === 'string' && answer.trim() === '';
        },
        is_empty_non_file_answer(answer) {
            return (
              this.is_missing_answer(answer) ||
              this.is_empty_array_answer(answer) ||
              this.is_empty_string_answer(answer)
            );
        },
        is_empty_question_answer(questionSection, question_id) {
            const question_type  = this.get_question_type(questionSection);
            const answer = this.get_question_value(question_id);
            const attached_file= Reflect.get(this.form_files, question_id);

            if (question_type  === 'file') {
              return !attached_file;
            }

            return this.is_empty_non_file_answer(answer);
        },
        has_required_question_error(questionSection) {
            const question_id = this.get_question_section_id(questionSection);

            if (!question_id) {
              return false;
            }

            if (!this.is_question_required(questionSection)) {
              return false;
            }

            return this.is_empty_question_answer(questionSection, question_id);
        },
        get_payload_answer_value(questionSection, question_id) {
            const question_type  = this.get_question_type(questionSection);
            const raw_answer = this.get_question_value(question_id);
            const attached_file= Reflect.get(this.form_files, question_id);

            if (question_type  === 'file') {
              return attached_file ?.name || '';
            }

            return Array.isArray(raw_answer) ? raw_answer.join(',') : raw_answer;
        },
        append_payload_file(formData, question_id) {
            const attached_file= Reflect.get(this.form_files, question_id);

            if (attached_file ) {
              formData.append(`file_${question_id}`, attached_file );
            }
        },
        add_question_answer_payload(answers, questionSection, formData) {
            const question_id = this.get_question_section_id(questionSection);

            if (!question_id) {
              return answers;
            }

            answers.push({
              question_id: question_id,
              answer: this.get_payload_answer_value(questionSection, question_id),
            });

            this.append_payload_file(formData, question_id);
            return answers;
        },
        show_portal_form_toast(icon, title, text, timer = 3000) {
            Swal.fire({
              icon: icon,
              title: title,
              text: text,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: timer,
              toast: true
            });
        },
        show_missing_profile_error() {
            this.show_portal_form_toast(
              'error',
              'Profile not found',
              'Please select an active profile before submitting this form.'
            );
        },
        show_incomplete_form_error() {
            this.show_portal_form_toast(
              'error',
              'Incomplete form',
              'Please answer all required questions before submitting.'
            );
        },
        can_submit_portal_form(formItem, base_profile_id) {
            if (this.is_form_locked(formItem)) {
              return false;
            }

            if (!base_profile_id) {
              this.show_missing_profile_error();
              return false;
            }

            if (!this.validate_portal_form(formItem)) {
              this.show_incomplete_form_error();
              return false;
            }

            return true;
        },
        build_portal_form_data(formItem, base_profile_id) {
            const form_data = new FormData();

            form_data.append('base_profile_id', base_profile_id);
            form_data.append('form_id', formItem?.form?.id || '');
            form_data.append('portal_form_id', formItem?.id || '');
            form_data.append(
              'answers',
              JSON.stringify(this.build_form_answers_payload(formItem, form_data))
            );

            return form_data;
        },
        set_form_submitting(form_id, isSubmitting) {
            this.submitting_forms = {
              ...this.submitting_forms,
              [form_id]: isSubmitting,
            };
        },
        mark_form_submitted(form_id) {
            this.submitted_form_ids = {
              ...this.submitted_form_ids,
              [form_id]: true,
            };
            this.form_errors = {};
        },
        handle_portal_form_success(response, form_id) {
            if (response.status === "success") {
              this.mark_form_submitted(form_id);
              this.show_portal_form_toast(
                'success',
                'Form submitted',
                'Your answers have been submitted successfully.',
                2000
              );
              return;
            }

            this.show_portal_form_toast(
              'error',
              'Submission failed',
              response.message || 'Unable to submit this form right now.'
            );
        },
        handle_portal_form_error(xhr) {
            this.show_portal_form_toast(
              'error',
              'Submission failed',
              xhr.responseJSON?.message || 'Unable to submit this form right now.'
            );
        },
        post_portal_form(form_data, form_id) {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/answer_questions_for_portal/`,
                type: "POST",
                headers: {
                  "Authorization": `Token ${this.getToken()}`,
                },
                data: form_data,
                processData: false,
                contentType: false,
                success: (response) => {
                  this.handle_portal_form_success(response, form_id);
                },
                error: (xhr) => {
                  this.handle_portal_form_error(xhr);
                },
                complete: () => {
                  this.set_form_submitting(form_id, false);
                }
            });
        },
        is_success_response(response) {
            return response.status === "success";
        },
        get_response_forms(response) {
            const data = response.data || [];
            const forms = Reflect.get(data, 'forms') || data;
            return Array.isArray(forms) ? forms : [];
        },
        handle_portal_forms_success(response) {
            if (!this.is_success_response(response)) {
              return;
            }

            this.portal_forms = this.get_response_forms(response);
            this.hydrate_form_answers(this.portal_forms);
        },
};
